import { message } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdOutlineFileUpload } from 'react-icons/md';

import Button from 'components/Buttons';

import FormField from '../Field';
import * as Styled from './Upload.styles';

type UploadProps = {
  id: string;
  onUploadFile: (file: File | null) => void;
  accept?: string;
};

const Upload = ({ id, onUploadFile, accept }: UploadProps) => {
  const [uploadedFiles, setUploadedFiles] = useState<RcFile[]>([]);
  const { t } = useTranslation();

  const handleBeforeUpload = (file: RcFile) => {
    const isPDF = file.type === 'application/pdf';
    if (!isPDF) {
      message.error(t('error.uploadFileWrongType'));
    } else {
      onUploadFile(file);
      setUploadedFiles([file]);
    }

    return false;
  };

  const handleRemove = () => {
    onUploadFile(null);
    setUploadedFiles([]);
  };

  return (
    <Styled.UploadArea
      id={id}
      maxCount={1}
      beforeUpload={handleBeforeUpload}
      fileList={uploadedFiles}
      onRemove={handleRemove}
      accept={accept}
    >
      <MdOutlineFileUpload style={{ fontSize: '24px' }} />
      <p>{t('certificate.dragAndDrop')}</p>
      <p>{t('certificate.or')}</p>
      <Button>{t('certificate.selectFile')}</Button>
    </Styled.UploadArea>
  );
};

const FormUpload = FormField<any>(Upload);

export default FormUpload;
